/** Comunicación popup ↔ pestaña principal del BNT Asistente. */

export const BNT_MAIN_WINDOW_NAME = "bnt-visor-main";
export const BNT_ASISTENTE_WINDOW_NAME = "bnt-asistente";

export const BNT_MSG_MINIMIZE = "bnt-asistente:minimize";
export const BNT_MSG_FOCUS_MAIN = "bnt-asistente:focus-main";
export const BNT_MSG_SET_TAB = "bnt-asistente:set-tab";

export const BNT_ASISTENTE_POPUP_ACTIVE_KEY = "visor:bnt_asistente_popup_active";

function sameOrigin(event) {
  return event?.origin === window.location.origin;
}

export function isBntAsistenteMessage(data) {
  if (!data || typeof data.type !== "string") return false;
  return data.type.startsWith("bnt-asistente:");
}

export function postToOpener(message) {
  if (typeof window === "undefined") return false;
  if (!window.opener || window.opener.closed) return false;
  try {
    window.opener.postMessage(message, window.location.origin);
    return true;
  } catch {
    return false;
  }
}

export function postToAssistantPopup(message) {
  if (typeof window === "undefined") return false;
  const popup = window.open("", BNT_ASISTENTE_WINDOW_NAME);
  if (!popup || popup.closed) return false;
  try {
    popup.postMessage(message, window.location.origin);
    return true;
  } catch {
    return false;
  }
}

/** Enfoca la pestaña principal o abre el sistema en ventana nombrada. */
export function focusOrOpenMainSystem({ path = "/" } = {}) {
  if (typeof window === "undefined") return null;
  const normalized = normalizeMainSystemPath(path);
  const url = `${window.location.origin}${normalized}`;
  if (window.opener && !window.opener.closed) {
    postToOpener({ type: BNT_MSG_FOCUS_MAIN, path: normalized });
    window.opener.focus();
    return window.opener;
  }
  const main = window.open(url, BNT_MAIN_WINDOW_NAME);
  if (main) main.focus();
  return main;
}

/** Ruta interna del sistema (pathname + search + hash). */
export function normalizeMainSystemPath(path = "/") {
  const raw = String(path || "/").trim() || "/";
  if (/^https?:\/\//i.test(raw)) {
    try {
      const u = new URL(raw);
      return `${u.pathname}${u.search}${u.hash}` || "/";
    } catch {
      return "/";
    }
  }
  return raw.startsWith("/") ? raw : `/${raw}`;
}

export function markAssistantPopupActive(active) {
  if (typeof window === "undefined") return;
  if (active) {
    window.sessionStorage.setItem(BNT_ASISTENTE_POPUP_ACTIVE_KEY, "1");
  } else {
    window.sessionStorage.removeItem(BNT_ASISTENTE_POPUP_ACTIVE_KEY);
  }
}

export function readAssistantPopupActive() {
  if (typeof window === "undefined") return false;
  return window.sessionStorage.getItem(BNT_ASISTENTE_POPUP_ACTIVE_KEY) === "1";
}
